import api from './client';

// Alerts API
export const alertsAPI = {
  getAll: (params) => api.get('/alerts', { params }),
  markRead: (id) => api.put(`/alerts/${id}/read`),
  markAllRead: (entityId) => api.put('/alerts/mark-all-read', null, { params: { entity_id: entityId } }),
  runChecks: () => api.post('/alerts/run-checks'),
};
